<template>
  <div class="stage-page">
    <div class="back_box">
      <div class="back_btn" @click="backPage">
        <img src="https://resources.sxsaas.com/static/jigou-saas-app/jiantou.png" alt="">
        <div class="text">返回</div>
      </div>
      <div class="class_name">报告分组列表</div>
    </div>
    <div class="main_box">
      <div class="stage_list" v-if="stageList.length > 0">
        <div class="stage_item" v-for="(item, index) in stageList" :key="item.id" @click="goToReportList(item)">
          <div class="stage_index">{{ String(index + 1).padStart(2, '0') }}</div>
          <div class="stage_icon_wrap">
            <div class="stage_icon">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#fff" stroke-width="1.8">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </div>
          </div>
          <div class="stage_info">
            <div class="stage_name">{{ item.name }}</div>
            <div class="stage_desc">{{ item.description || '暂无描述' }}</div>
          </div>
          <div class="stage_count">
            <div class="count_badge">
              <span class="num">{{ item.report_count || 0 }}</span>
            </div>
            <span class="label">份报告</span>
          </div>
          <div class="stage_arrow">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </div>
        </div>
      </div>
      <div class="empty_box" v-else-if="!loading">
        <div class="empty_icon_wrap">
          <svg viewBox="0 0 80 80" width="80" height="80" fill="none">
            <rect x="10" y="16" width="60" height="48" rx="6" stroke="#d0d5e8" stroke-width="2"/>
            <line x1="24" y1="32" x2="56" y2="32" stroke="#d0d5e8" stroke-width="2" stroke-linecap="round"/>
            <line x1="24" y1="42" x2="48" y2="42" stroke="#d0d5e8" stroke-width="2" stroke-linecap="round"/>
            <line x1="24" y1="52" x2="40" y2="52" stroke="#d0d5e8" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="empty_text">暂无报告分组</div>
        <div class="empty_sub">当前项目还没有配置报告分组</div>
      </div>
    </div>
    <div class="page_end_fixed">
      <endBox></endBox>
    </div>
  </div>
</template>

<script>
import * as openReportApi from '@/api/openReport.js'

export default {
  data() {
    return {
      stageList: [],
      loading: true
    }
  },
  computed: {},
  created() {
    this.fetchStages()
  },
  methods: {
    async fetchStages() {
      this.loading = true
      try {
        var proId = this.$route.query.pro_id || window.localStorage.getItem('proID')
        var user = JSON.parse(window.localStorage.getItem('user') || '{}')
        var stuId = user.stu_id || 0
        var res = await openReportApi.getStudentStages(proId, stuId)
        if (res.data.code === 200) {
          var list = res.data.data.data || []
          list.sort(function (a, b) { return (a.sort_order || 0) - (b.sort_order || 0) })
          // 通过4.5接口获取每个阶段的实际报告数量，取不到则保留4.4返回的report_count
          var countPromises = list.map(function (stage) {
            return openReportApi.getStudentReports(proId, stuId, {
              stage_id: stage.id,
              page: 1,
              page_size: 100
            }).then(function (r) {
              if (r.data && r.data.code === 200 && r.data.data) {
                var list = Array.isArray(r.data.data) ? r.data.data : (r.data.data.data || [])
                if (list.length > 0) {
                  stage.report_count = list.length
                }
              }
            }).catch(function () {})
          })
          await Promise.all(countPromises)
          this.stageList = list
        }
      } catch (e) {
        console.error('获取报告阶段列表失败', e)
        this.$message({ message: '获取报告分组失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    goToReportList(stage) {
      this.$router.push({
        name: 'ReportList',
        query: {
          pro_id: this.$route.query.pro_id || window.localStorage.getItem('proID'),
          stage_id: stage.id,
          stage_name: stage.name
        }
      })
    },
    backPage() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.stage-page {
  background: #f0f2f8;
}
.back_box {
  width: 1160px;
  height: 60px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  margin: 20px auto 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(116, 125, 254, 0.08);
}
.back_btn {
  width: 95px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(122, 152, 249, 1);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s;
  color: #747DFE;
  font-size: 14px;
}
.back_btn:hover {
  background: rgba(116, 125, 254, 0.08);
  transform: translateX(-2px);
}
.back_btn img { width: 20px; height: 20px; }
.back_btn .text { margin-top: -1px; margin-left: 8px; }
.class_name {
  color: rgba(22, 27, 38, 1);
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 0.5px;
}
.main_box {
  width: 1160px;
  margin: 0 auto;
  background: #fff;
  box-sizing: border-box;
  padding: 24px;
  min-height: 400px;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(116, 125, 254, 0.06);
}

/* 列表 */
.stage_list { display: flex; flex-direction: column; gap: 12px; }
.stage_item {
  display: flex;
  align-items: center;
  padding: 20px 24px;
  background: #fafbff;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid transparent;
  position: relative;
}
.stage_item:hover {
  background: #fff;
  border-color: rgba(116, 125, 254, 0.25);
  box-shadow: 0 4px 20px rgba(116, 125, 254, 0.12);
  transform: translateY(-2px);
}
.stage_index {
  font-size: 13px;
  font-weight: 600;
  color: #c8cce0;
  margin-right: 16px;
  min-width: 24px;
}
.stage_item:hover .stage_index { color: #747DFE; }
.stage_icon_wrap { margin-right: 16px; }
.stage_icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #747DFE 0%, #8B93FF 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
}
.stage_item:hover .stage_icon { transform: scale(1.05); }
.stage_info { flex: 1; }
.stage_name {
  font-size: 16px;
  font-weight: 600;
  color: #1e2330;
  margin-bottom: 6px;
  transition: color 0.2s;
}
.stage_item:hover .stage_name { color: #747DFE; }
.stage_desc { font-size: 13px; color: #a0a4b8; line-height: 1.4; }
.stage_count {
  text-align: center;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.count_badge {
  background: linear-gradient(135deg, #747DFE 0%, #8B93FF 100%);
  border-radius: 10px;
  padding: 6px 14px;
  min-width: 48px;
}
.count_badge .num {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}
.stage_count .label { font-size: 12px; color: #a0a4b8; }
.stage_arrow {
  color: #c8cce0;
  transition: all 0.3s;
}
.stage_item:hover .stage_arrow {
  color: #747DFE;
  transform: translateX(4px);
}

/* 空状态 */
.empty_box { text-align: center; padding: 80px 0; }
.empty_icon_wrap { margin-bottom: 20px; opacity: 0.6; }
.empty_text { color: #666; font-size: 16px; font-weight: 500; margin-bottom: 8px; }
.empty_sub { color: #b0b4c8; font-size: 13px; }

.page_end_fixed { width: 100%; margin-top: 20px; }
</style>
